import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './QuickRead.css';
import * as actions from './Actions';
import { fetchInitialData } from "../fetchData";
import Right from '../right/Right';
import Service from '../service/Service';
// import { Bling as GPT } from "react-gpt";
import User from './common/QuickUsers';
import QuickLinks from './common/QuickLinks';
import QuickContent from './common/QuickContent';
import CommentOverlay from './common/QuickCommentOverlay';
import UserListOverlay from './common/UserListOverlay';
import withContext from "../../withContext";
import { AdSlot, DFPSlotsProvider } from 'react-dfp'

const service = new Service();
var player = {};

class QuickRead extends Component {
    constructor(props) {
        super(props);
        let isWindow = false;
        if (__isBrowser__) {
            isWindow = true;
        }
        let initialData = [];
        let serverSideData = {};
        this.totalCount = 0;
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData && serverSideData['result']) {
            initialData = serverSideData['result'];
            this.totalCount = parseInt(serverSideData['discussionCount']);
        }
        console.log("Quickread data=====>", initialData)
        this.state = {
            initialData: initialData,
            metaTitle: "Quick Reads - Planning, Pregnancy, Baby Care, Parenting Tips & Advice",
            metaDescription: [
                { "name": "description", "content": "FirstCry Parenting offers quick reads for time-starved parents. It is personalized bite-sized content on planning, pregnancy, baby care & parenting tips that you will enjoy reading & sharing on-the-go." }
            ],
            isWindow: isWindow,
            fileLoadStatus: 'start',
            //videoUrl: 'https://vcdn.cdnparenting.com/customerTrans/8496bf8579ab2d9133938760f06535d7/32fcd2fc-174c5062857-0015-0a5a-b51-e6ec6.mp4'
        };

        this.disPageNo = 1;
        if (this.props.params.page && this.props.params.page > 0) {
            this.disPageNo = parseInt(this.props.params.page);
        }
        this.maxScroll = 0;
        this.timeout = 0;
        this.playVideoId = "";
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {

        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let size = 10;
        if (reqUrl.includes('/page/')) {
            size = parseInt(reqUrl.split('/').pop()) * 10;
        }
        let pageno = parseInt(reqUrl.split('/')[5])
        if (pageno) {
            pageno = pageno;
        } else {
            pageno = 1;
        }
        var url = global.api_url + "discussion/getdiscussionlist";
        let body = JSON.stringify({
            "pagesize": 10,
            "pageno": 1,
            "moduleType": "quickbites"
        })
        return fetchInitialData(url, JSON.stringify(header), body);
    }

    componentDidMount() {
        var self = this;
        if (self.state.isWindow && self.state.fileLoadStatus === 'start') {
            self.setState({ fileLoadStatus: 'loading' }, () => {
                setTimeout(function () {
                    service.do_load_files(self, player);
                }, 0);
            })
        }
        document.addEventListener("click", actions.domClick);
        this.pageData = this.pageData.bind(this);
        window.addEventListener("scroll", this.pageData, false);
        if (navigator.onLine) {
            let size = 10;
            if (this.disPageNo > 1) {
                size = 10 * this.disPageNo;
            }
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
                this.discussionData(1, size);
            } else {
                localStorage.setItem('quickreadLanding', JSON.stringify(this.state.initialData));
                localStorage.setItem('quickreadLandingCnt', JSON.stringify(this.totalCount));
                actions.loadSliders();
                actions.loadReadMore();
                // player = service.initializeVideoPlayer(this, player);
            }
        } else {
            if (localStorage.getItem('quickreadLanding')) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('quickreadLanding')) }, () => { actions.loadSliders(); actions.loadReadMore(); player = service.initializeVideoPlayer(this, player); });
            }
            if (localStorage.getItem('quickreadLandingCnt')) {
                this.totalCount = localStorage.getItem('quickreadLandingCnt');
            }
            service.hideLoader();

        }
        //console.log("initialData for quickread--- ",this.state.initialData);
        actions.setWidth();
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.pageData, false);
        document.removeEventListener("click", actions.domClick);
    }

    // appendURL() {
    //     this.props.history.push(service.getRedirectUrl("/quick-reads/page/" + this.disPageNo));
    // }

    pageData() {
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            if (document.getElementsByClassName('data-container')[0]) {
                var cS = document.getElementsByClassName('data-container')[0].offsetTop;
                var cH = document.getElementsByClassName('data-container')[0].offsetHeight - 2000,
                    wS = window.scrollY - cS;
                if (!((window.innerHeight + window.scrollY) >= document.body.offsetHeight) && wS > cH) {
                    if (wS > _this.maxScroll && _this.totalCount > (_this.disPageNo * 10)) {
                        _this.maxScroll = wS;
                        ++_this.disPageNo;
                        service.showLoader();
                        service.showTracking();
                        _this.discussionData(_this.disPageNo, 10);
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
    }

    discussionData(pageno, size) {
        // debugger;
        var postData = {
            "pagesize": size,
            "pageno": pageno,
            "moduleType": "quickbites"
        }
        // var url = global.api_url + "discussion/getdiscussionlist";
        var url = global.api_ci_url + "QuickReads/getdiscussionlist";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                if (this.state.initialData.length > 0) {
                    if (size == (pageno * 10)) {
                        this.setState({ initialData: json['result'] }, () => { service.loadImages(); actions.loadSliders(); actions.loadReadMore(); player = service.initializeVideoPlayer(this, player); });
                    } else {
                        let ary = this.state.initialData;
                        this.setState({ initialData: ary.concat(json['result']) }, () => { service.loadImages(); actions.loadSliders(); actions.loadReadMore(); player = service.initializeVideoPlayer(this, player); });
                    }
                    // if (parseInt(pageno) != 1) {
                    //     this.appendURL();
                    // }
                } else {
                    localStorage.setItem('quickreadLanding', JSON.stringify(json['result']));
                    localStorage.setItem('quickreadLandingCnt', JSON.stringify(json['discussionCount']));
                    this.totalCount = parseInt(json['discussionCount']);
                    this.setState({ initialData: json['result'] }, () => { service.loadImages(); actions.loadSliders(); actions.loadReadMore(); player = service.initializeVideoPlayer(this, player); });
                }
            }
            service.hideLoader();
            service.hideTracking();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
            service.hideTracking();
        });
    }
    changeData(id, type, status) {
        let QuickLinks = this.state.initialData;
        QuickLinks && QuickLinks.forEach((content) => {
            if (content.discussionId == id) {
                if (type == "LikeAction") {
                    if (parseInt(status) == 1) {
                        // console.log("successss====>",articles.articleId);
                        content.isMyLike = 1;
                        content.likeCount = parseInt(content.likeCount) + 1;
                    } else if (parseInt(status) == 0) {
                        content.isMyLike = 0;
                        content.likeCount = parseInt(content.likeCount) - 1;
                    }
                } else if (type == "commentAction") {
                    if (parseInt(status) == 1) {
                        content.isMyComment = 1;
                        content.commentCount = parseInt(content.likeCount) + 1;
                    } else if (parseInt(status) == 0) {
                        content.isMyComment = 0;
                        content.likeCount = parseInt(content.commentCount) - 1;
                    }
                }
            }
        });
        this.setState({ initialData: QuickLinks });
    }
    reloadData() {
        var _this = this;
        setTimeout(() => {
            service.showLoader();
            _this.discussionData(_this.disPageNo, (_this.disPageNo * 10));

        }, 500)

        if (this.playVideoId != "") {
            let ele = document.getElementById(this.playVideoId);
            console.log(service.isInViewport(ele));
            if (!service.isInViewport(ele)) {
                player[this.playVideoId].pause();
            }
        }
    }
    render() {
        return (
            <main className="quickread-main main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Quick Reads</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Quick Reads on Pregnancy, Baby Care & Parenting</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        {this.state.initialData && this.state.initialData.map((quickread, index) =>
                            <div key={index}>
                                <div className="quickread-block" data-title={quickread.title} data-id={quickread.discussionId} id={`quick-reads_${quickread.discussionId}`}>
                                    <Link to={service.getRedirectUrl(`/user-profile/${service.replaceSymbols(quickread.userId)}`)}>
                                        <User user={quickread} isAnonymus={0} eleRef={this} />
                                    </Link>
                                    <QuickContent quickread={quickread} linkUrl={`/quick-reads/${service.replaceSymbols(quickread.quickreadtype)}/${service.replaceSymbols(quickread.title)}/${quickread.discussionId}`} isDisLanding={true} eleRef={this} />
                                    <div className="divider_line"></div>
                                    <QuickLinks quickread={quickread} eleRef={this} title={quickread.title} quickReadType={quickread.quickreadtype} />
                                </div>

                                {__isBrowser__ && index == 0 &&
                                    <div>
                                        {/* for india */}
                                        <div id="vdo_ai_div"></div><script>{(function (v, d, o, ai) { ai = d.createElement('script'); ai.defer = true; ai.async = true; ai.src = v.location.protocol + o; d.head.appendChild(ai); })(window, document, '//a.vdo.ai/core/v-parenting-firstcry-v2/vdo.ai.js')}</script>
                                        {/* for outside india */}
                                        {/* <div id="vdo_ai_div"></div><script>{(function (v, d, o, ai) { ai = d.createElement('script'); ai.defer = true; ai.async = true; ai.src = v.location.protocol + o; d.head.appendChild(ai); })(window, document, '//a.vdo.ai/core/v-parenting-firstcry-v3/vdo.ai.js')}</script> */}
                                    </div>
                                }
                                {((index + 1) % 4 == 0) &&
                                    <div>
                                        <div className="desktop-ads-block" role="img" aria-label="Advertisement unit" tabIndex={0}>
                                            <div id="div-gpt-ad-1592993533680-0" style={{ width: '696px', height: '200px', overflow: 'hidden', margin: '0 auto' }}>
                                                {/* <GPT
                                                    adUnitPath="/84382175/parenting.com/parenting.com_Discussion_Desktop"
                                                    slotSize={[[696, 200], [336, 280], [728, 90], [300, 250]]}
                                                /> */}
                                                <DFPSlotsProvider
                                                    // dfpNetworkId={gptAry['desktop']['id']}
                                                    adUnitPath="/84382175/parenting.com/parenting.com_Discussion_Desktop"
                                                    slotSize={[[696, 200], [336, 280], [728, 90], [300, 250]]}
                                                ></DFPSlotsProvider>
                                            </div>
                                        </div>
                                        <div className="msite-ads-block" role="img" aria-label="Advertisement unit" tabIndex={0}>
                                            <div id="div-gpt-ad-1592993525621-0" style={{ width: '320px', height: '50px', overflow: 'hidden', margin: '0 auto' }}>
                                                {/* <GPT
                                                    adUnitPath="/84382175/parenting.com/parenting.com_Discussion_Msite"
                                                    slotSize={[[336, 280], [300, 250], [320, 100], [320, 50]]}
                                                /> */}
                                                <DFPSlotsProvider
                                                    // dfpNetworkId={gptAry['desktop']['id']}
                                                    adUnitPath="/84382175/parenting.com/parenting.com_Discussion_Msite"
                                                    slotSize={[[336, 280], [300, 250], [320, 100], [320, 50]]}
                                                ></DFPSlotsProvider>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        )}
                        {(!this.state.initialData || this.state.initialData.length < 1) &&
                            <div className="quickread-block"></div>
                        }
                    </div>
                </div>
                <input type="hidden" id="post_commentId" value="" />
                <input type="hidden" id="post_parentUserId" value="" />
                <input type="hidden" id="post_parentUserName" value="" />
                <input type="hidden" id="post_parentIsAnonymus" value="" />
                <input type="hidden" id="post_replyId" value="" />
                <input type="hidden" id="post_dId" value="" />
                <input type="hidden" id="post_gId" value="" />
                <input type="hidden" id="post_cId" value="" />
                <input type="hidden" id="post_dUrl" value="" />
                <CommentOverlay eleRef={this} />
                <UserListOverlay eleRef={this} />
                <div className="share-overlay"></div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withContext(QuickRead);
